import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import { useDropdown } from './DropdownContext';
import Icon from 'Components/Atoms/Icon/Icon';

export default function DropdownToggle({ children, className }) {
    const { isOpen, reference, getReferenceProps } = useDropdown();

    return (
        <button
            type="button"
            ref={reference}
            className={cn(
                'inline-flex items-center justify-between gap-2 h-11 w-full pl-3 pr-2 text-left text-sm text-dark-blue bg-white border border-gray-200 rounded-md shadow-sm transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary',
                isOpen && 'border-primary ring-2 ring-primary/20',
                className,
            )}
            {...getReferenceProps()}
        >
            {children}
            <Icon name="chevron-down" color="currentColor" />
        </button>
    );
}

DropdownToggle.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
